import { render, staticRenderFns } from "./ImportTransferenciasParticipantes.vue?vue&type=template&id=cb05fe4a&"
import script from "./ImportTransferenciasParticipantes.vue?vue&type=script&lang=js&"
export * from "./ImportTransferenciasParticipantes.vue?vue&type=script&lang=js&"
import style0 from "./ImportTransferenciasParticipantes.vue?vue&type=style&index=0&id=cb05fe4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports